<div class="rich-editor-container">
    <editor
        [init]="tinymceInit"
        [(ngModel)]="value"
        [disabled]="disabled"
        (onInit)="editorReady.emit($event)"
        (onChange)="onEditorChange($event)"
        (onBlur)="onEditorBlur()">
    </editor>
</div>
